<script setup>
import { CRITERIA } from '../lib/criteria.js'
import { num } from '../lib/format.js'

defineProps({
  filters: { type: Object, required: true },
  pipelines: { type: Array, default: () => [] },
  owners: { type: Array, default: () => [] },
  count: { type: Number, default: 0 },
})
const emit = defineEmits(['export'])

const imprimir = () => window.print()
</script>

<template>
  <div class="card filtros no-print">
    <label>
      <span>Pipeline</span>
      <select v-model="filters.pipelineId">
        <option value="todos">Todos</option>
        <option v-for="p in pipelines" :key="p.id" :value="p.id">{{ p.name }} ({{ p.unmanaged }})</option>
      </select>
    </label>
    <label>
      <span>Motivo</span>
      <select v-model="filters.reason">
        <option value="todos">Todos</option>
        <option v-for="c in Object.values(CRITERIA)" :key="c.id" :value="c.id">{{ c.label }}</option>
      </select>
    </label>
    <label>
      <span>Severidad</span>
      <select v-model="filters.severity">
        <option value="todas">Todas</option>
        <option value="critico">Critico</option>
        <option value="alto">Alto</option>
        <option value="medio">Medio</option>
      </select>
    </label>
    <label>
      <span>Responsable</span>
      <select v-model="filters.owner">
        <option value="todos">Todos</option>
        <option value="sin_asignar">Sin asignar</option>
        <option v-for="o in owners" :key="o" :value="o">{{ o }}</option>
      </select>
    </label>
    <label class="grow">
      <span>Buscar</span>
      <input v-model="filters.search" placeholder="nombre, email, telefono o etapa" />
    </label>
    <div class="acciones">
      <span class="muted mono">{{ num(count) }} leads</span>
      <button @click="emit('export')">Exportar CSV</button>
      <button @click="imprimir">Imprimir</button>
    </div>
  </div>
</template>

<style scoped>
.filtros { display: flex; flex-wrap: wrap; gap: 12px; align-items: flex-end; padding: 12px 16px; margin-bottom: 16px; }
label { display: grid; gap: 4px; font-size: 12px; color: var(--muted); }
label.grow input { width: 100%; min-width: 200px; }
.acciones { display: flex; gap: 8px; align-items: center; margin-left: auto; }
</style>
